<template>
    <v-container fluid class="pa-6">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span class="page-title">{{ page.title }}</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="dataset.breadcrumbItems"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn type="button" elevation="0" color="primary" @click="update()">Atualizar</v-btn>
                        <v-btn id="btnBack" type="button" elevation="0" color="primary" outlined to="/home">Voltar</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-form ref="form" v-model="dataForm.validForm">
            <v-row>
                <v-col cols="12">
                    <v-card class="card-form-outlined">
                        <v-card-title class="card-group-title">Detalhes do Credor</v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12" sm="4">
                                    <v-text-field dense id="name" label="Nome completo" v-model="dataset.data.name"
                                        required :rules="[$rules.required]" outlined hide-details="auto">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-text-field dense label="E-mail" v-model="dataset.data.email" disabled required
                                        outlined hide-details="auto">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-text-field dense id="registration" label="CPF/CNPJ"
                                        v-model="dataset.data.registration" disabled required v-mask="['###.###.###-##', '##.###.###/####-##']"
                                        :rules="[$rules.required, validateRegistration]"
                                        outlined hide-details="auto">
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="mt-4">
                                <v-col cols="12" sm="4">
                                    <v-text-field dense label="Telefone" v-model="dataset.data.phone_number" disabled
                                        v-mask="['(##) ####-####', '(##) #####-####']" outlined hide-details="auto">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-text-field dense label="Valor (R$)" v-model="dataset.data.amount" disabled type="number"
                                        outlined hide-details="auto">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" sm="4" class="d-flex align-center">
                                    <span class="text-uppercase font-weight-bold primary--text" color="primary">
                                        TIPO DE CREDOR: 
                                    </span>
                                    <span class="ml-2">{{ dataset.data.type | enum(dataset.userTypes, "id", "name") }}</span>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-form>

        <!-- <v-row>
            <v-col cols="12">
                <v-card class="card-form-outlined" color="gray">
                    <v-card-title class="card-group-title">
                        <div class="title-container" style="width: 100%;">
                            <div class="title-block">
                                <span class="table-card-title">Documentos</span>
                            </div>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <v-alert type="info" outlined dense class="mb-0">
                            Nenhum documento encontrado.
                        </v-alert>
                        </v-card-text>
                </v-card>
            </v-col>
        </v-row> -->

        <v-row>
            <v-col cols="12">
                <v-card class="card-form-outlined" color="gray">
                    <v-card-title class="card-group-title">
                        <div class="title-container" style="width: 100%;">
                            <div class="title-block">
                                <span class="table-card-title">Dados Bancários</span>
                            </div>
                            <div class="button-group">
                                <v-tooltip bottom>
                                    <template #activator="{ on }">
                                        <v-btn v-on="on" icon @click="downloadBankInfoCsv()" :loading="dataset.downloadingCsv">
                                            <v-icon size="28">mdi-file-excel</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Baixar planilha de dados (Excel)</span>
                                </v-tooltip>
                            </div>
                        </div>
                    </v-card-title>
                    
                    <v-card-text v-if="dataset.bankInfo">
                        <v-row>
                            <v-col cols="12" :sm="dataset.bankInfo.lawyer_id ? 6 : 12">
                                <v-text-field dense label="Titularidade da conta" 
                                    :value="dataset.bankInfo.lawyer_id ? 'Conta de Procurador' : 'Conta Própria'" 
                                    readonly outlined hide-details="auto">
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" v-if="dataset.bankInfo.lawyer_id">
                                <v-text-field dense label="Nome do Procurador"  
                                    :value="dataset.bankInfo.lawyer ? dataset.bankInfo.lawyer.name : 'Nome indisponível'" 
                                    readonly outlined hide-details="auto">
                                </v-text-field>
                            </v-col>
                        </v-row>

                        <v-row class="mt-2">
                            <v-col cols="12" sm="6">
                                <v-text-field dense label="Nome do banco" disabled :value="dataset.bankInfo.bank_name" readonly outlined hide-details="auto"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field dense label="Número do banco" disabled :value="dataset.bankInfo.bank_code" readonly outlined hide-details="auto"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="mt-2">
                            <v-col cols="12" sm="4">
                                <v-text-field dense label="Agência" disabled :value="dataset.bankInfo.agency" readonly outlined hide-details="auto"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="5">
                                <v-text-field dense label="Número da conta" disabled :value="dataset.bankInfo.account_number" readonly outlined hide-details="auto"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="3">
                                <v-text-field dense label="Dígito" disabled :value="dataset.bankInfo.account_digit" readonly outlined hide-details="auto"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="mt-2">
                            <v-col cols="12" sm="6">
                                <v-text-field dense label="Tipo de conta" disabled :value="dataset.accountTypes[dataset.bankInfo.account_type]" readonly outlined hide-details="auto"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field dense label="CPF/CNPJ" disabled :value="dataset.bankInfo.registration ? formatCpfCnpj(dataset.bankInfo.registration) : ''" readonly outlined hide-details="auto"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="mt-2">
                            <v-col cols="12" sm="6">
                                <v-text-field dense label="Tipo de chave PIX" disabled :value="dataset.pixKeyTypes[dataset.bankInfo.pix_type]" readonly outlined hide-details="auto"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-text-field dense label="Chave PIX" disabled :value="dataset.bankInfo.pix_key" readonly outlined hide-details="auto"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-text v-else>
                        <v-alert type="info" outlined dense class="mb-0">
                            Nenhum dado bancário cadastrado para este credor.
                        </v-alert>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card class="card-form-outlined" color="gray">
                    <v-card-title class="card-group-title">
                        <div class="title-container" style="width: 100%;">
                            <div class="title-block">
                                <span class="table-card-title">Comprovante de Pagamento</span>
                            </div>
                        </div>
                    </v-card-title>

                    <v-card-text>
                        <v-row v-if="dataset.data.payment_receipt_url">
                            <v-col cols="12" sm="4" md="3">
                                <div class="text-center" style="border: 1px solid var(--v-gray-base); border-radius: 8px; padding: 16px; background-color: white;">
                                    <v-icon size="48" color="primary">mdi-file-document-check-outline</v-icon>
                                    <div class="mt-2 mb-3 font-weight-bold caption-text text-uppercase">Comprovante de pagamento</div>
                                    <v-btn type="button" elevation="0" color="primary" outlined small
                                        :href="dataset.data.payment_receipt_url" target="_blank">
                                        Visualizar
                                    </v-btn>
                                </div>
                            </v-col>
                        </v-row>

                        <v-divider class="my-4" v-if="dataset.data.payment_receipt_url"></v-divider>

                        <v-row align="center">
                            <v-col cols="12" sm="8">
                                <v-file-input
                                    dense
                                    outlined
                                    v-model="dataset.payment_receipt_file"
                                    accept="image/png, image/jpeg, application/pdf"
                                    prepend-icon=""
                                    prepend-inner-icon="mdi-paperclip"
                                    label="Anexar comprovante de pagamento"
                                    hint="Formatos aceitos: PDF, PNG, JPG (Max 15MB)"
                                    persistent-hint
                                    show-size
                                    hide-details="auto"
                                ></v-file-input>
                            </v-col>
                            <v-col cols="12">
                                <v-btn color="primary" elevation="0" @click="uploadReceipt" :loading="dataset.uploadingReceipt">
                                    Enviar Comprovante
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import 'moment/locale/pt-br';
import Vue from "vue";
import axios from 'axios';
import { cpf, cnpj } from 'cpf-cnpj-validator';
import userTypes from "@/common/data/user-types.data";

export default {
    name: "CreditorDetails",

    data: () => ({
        page: {
            title: "Detalhes do Credor",
        },
        dataset: {
            userTypes: userTypes,
            breadcrumbItems: [],
            data: {
                registration: "",
                amount: null,
                user_id: null,
                payment_receipt_url: null,
            },
            bankInfo: null,
            downloadingCsv: false,
            accountTypes: { 1: "Conta corrente", 2: "Conta poupança" },
            pixKeyTypes: { 1: "CPF", 2: "CNPJ", 3: "Celular", 4: "E-mail", 5: "Chave Aleatória" },
            payment_receipt_file: null, 
            uploadingReceipt: false,
        },
        dataForm: {
            validForm: true,
            loading: false,
        },
    }),

    created() {
        this.listBreadCrumbItems();
        this.loadData();
    },

    methods: {
        goBack() {
            this.$router.replace("/home");
        },

        listBreadCrumbItems() {
            this.dataset.breadcrumbItems = [
                { text: "Homepage", disabled: false, to: "/home", exact: true },
                { text: "Credores", disabled: false, to: "/credores", exact: true },
                { text: "Detalhes do Credor", disabled: true, exact: true },
            ];
        },

        validateRegistration(value) {
            if (!value) return true; 
            const cleanValue = value.replace(/\D/g, '');
            return cleanValue.length <= 11 ? this.$rules.cpf(value) : this.$rules.cnpj(value);
        },

        formatCpfCnpj(value) {
            if (!value) return '';
            const cleanValue = value.replace(/\D/g, '');
            return cleanValue.length === 14 ? cnpj.format(cleanValue) : cpf.format(cleanValue);
        },

        async loadData() {
            await this.load();

            if (this.dataset.data && this.dataset.data.user_id) {
                await this.loadBankInfo(this.dataset.data.user_id);
            }
        },

        async load() {
            try {
                const result = await axios.get('/api/admin/users-creditors/client', { 
                    params: { id: this.$route.params.id, limit: 1 } 
                });

                if (result.data.content && result.data.content.data && result.data.content.data.length > 0) {
                    const data = result.data.content.data[0];
                    
                    this.dataset.data = {
                        ...this.dataset.data,
                        creditor_id: data.id,       
                        user_id: data.user_id,      
                        name: data.name,
                        email: data.email,
                        phone_number: data.phone_number,
                        registration: data.registration,
                        amount: data.amount,
                        type: data.type,
                        payment_receipt_url: data.payment_receipt_url || null
                    };
                }
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error) || "Erro ao carregar usuário", { position: 'top-right', timeout: 2000 });
            }
        },

        async loadBankInfo(userId) {
            try {
                const result = await axios.get(`/api/admin/users/${userId}/bank-information/client`);
                
                if (result.data.content && Array.isArray(result.data.content.data) && result.data.content.data.length > 0) {
                    this.dataset.bankInfo = result.data.content.data[0];
                } else if (result.data.content && !Array.isArray(result.data.content)) {
                    this.dataset.bankInfo = result.data.content;
                }
            } catch (error) {
                console.log("Credor não possui dados bancários vinculados.");
            }
        },

        async downloadBankInfoCsv() {
            if (!this.dataset.data.user_id) {
                this.$dialog.notify.warning("Este credor não possui um usuário vinculado.", { position: 'top-right', timeout: 3000 });
                return;
            }

            this.dataset.downloadingCsv = true;
            try {
                const result = await axios.get(`/api/admin/users/${this.dataset.data.user_id}/bank-information/csv/client`, {
                    responseType: 'blob' 
                });
                
                // A API passou a devolver planilha Excel (.xlsx) em vez de CSV.
                let blob = new Blob([result.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                let link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = `dados_bancarios_${this.dataset.data.name.replace(/\s+/g, '_')}.xlsx`;
                link.click();
                
                this.$dialog.notify.info("Planilha gerada com sucesso!", { position: "top-right", timeout: 2000 });
            } catch (error) {
                this.$dialog.notify.error("Erro ao gerar planilha. O credor possui dados cadastrados?", { position: 'top-right', timeout: 3000 });
            } finally {
                this.dataset.downloadingCsv = false;
            }
        },

        async update() {
            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja atualizar os dados do credor?',
                title: 'Atualizar credor',
                actions: { false: 'Cancelar', true: 'Atualizar' }
            });

            if (!proceedAction) return;

            this.dataForm.loading = true;

            const payload = {
                name: this.dataset.data.name,
                email: this.dataset.data.email,
                phone_number: this.dataset.data.phone_number,
                amount: this.dataset.data.amount,
                registration: this.dataset.data.registration.replace(/\D/g, '') 
            };

            try {
                await axios.patch(`/api/admin/users-creditors/client/${this.$route.params.id}`, payload);
                this.$dialog.notify.info("Credor atualizado com sucesso!", { position: "top-right", timeout: 2000 });
                this.goBack();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error) || "Erro ao atualizar", { position: 'top-right', timeout: 2000 });
            } finally {
                this.dataForm.loading = false;
            }
        },

        async uploadReceipt() {
            if (!this.dataset.payment_receipt_file) {
                this.$dialog.notify.warning("Por favor, anexe um arquivo primeiro.", { position: 'top-right', timeout: 3000 });
                return;
            }

            this.dataset.uploadingReceipt = true;

            const formData = new FormData();
            formData.append("receipt", this.dataset.payment_receipt_file);

            try {
                await axios.patch(`/api/admin/users-creditors/client/${this.$route.params.id}/receipt`, formData, {
                    headers: { "Content-Type": "multipart/form-data" }
                });

                this.$dialog.notify.info("Comprovante anexado e enviado com sucesso!", { position: "top-right", timeout: 2000 });
                
                this.dataset.payment_receipt_file = null;
                
                await this.loadData();
            } catch (error) {
                this.$dialog.notify.error(this.$codes(error) || "Erro ao enviar comprovante", { position: 'top-right', timeout: 3000 });
            } finally {
                this.dataset.uploadingReceipt = false;
            }
        }
    },
};
</script>

<style lang="scss">
.title-page {
    color: var(--v-primary-base);
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}
.card-form-outlined {
    border: 1px solid var(--v-gray-base) !important;
}
.button-group {
    display: flex;
    gap: 10px;
}
</style>